<script setup lang="ts">
import RegionsStatisticsSection from '@/components/region-statistics/RegionsStatisticsSection.vue'
import AppLoadingWrapper from '@/components/app/AppLoadingWrapper.vue'
import ElectricityGridOwner from '@/components/region-statistics/ElectricityGridOwner.vue'
import { RegionType } from '~/types/types'
import { useGeoDataStore } from '~/stores/geoData'

const props = defineProps<{ regionType?: RegionType; regionId?: string }>()
const {
  data: ElectricityGridOwners,
  isReady,
  isLoading,
} = useElectricityGridOwnerDataFetch(props.regionType, props.regionId)
const geoDataStore = useGeoDataStore()
onMounted(async () => {
  await geoDataStore.initMunicipalities()
})
</script>

<template>
  <AppLoadingWrapper :is-loading="isLoading" :height="100">
    <ElectricityGridOwner
      v-for="owner in ElectricityGridOwners"
      :key="owner.koncession"
      :data="owner"
      :show-municipalities="regionType === 'county' || !regionType"
    />
  </AppLoadingWrapper>
</template>
